type SentryExceptionValue = {
  type?: unknown;
  value?: unknown;
};

type SentryEventLike = {
  exception?: {
    values?: SentryExceptionValue[];
  };
};

export function isBrowserNetworkFetchErrorValue(value: unknown): boolean {
  return (
    typeof value === 'string' &&
    /^Failed to fetch(?: \(api\.trycanary\.ai\))?$/.test(value)
  );
}

export function shouldDropNetworkFetchEvent(event: unknown): boolean {
  if (!event || typeof event !== 'object') {
    return false;
  }

  const sentryEvent = event as SentryEventLike;
  const exception = sentryEvent.exception?.values?.[0];
  if (!exception) {
    return false;
  }

  return (
    exception.type === 'TypeError' &&
    isBrowserNetworkFetchErrorValue(exception.value)
  );
}
